import React, { useState, useCallback } from 'react';

export const useQuickFilter: any = () => {
  const [filteredVins, setFilteredVins] = useState([]);
  const quickFilterParser = useCallback((quickFilter: any) => {
    let quickFilterParts = [];
    let sentence = quickFilter.trim();
    sentence = sentence?.split(/[\s,]+/)?.join();
    quickFilterParts = sentence?.split(',');
    setFilteredVins(quickFilterParts);
    return quickFilterParts;
  }, []);

  const quickFilterMatcher = useCallback((quickFilterParts: any, rowQuickFilterAggregateText: any) => {
    return quickFilterParts?.some((part: any) => rowQuickFilterAggregateText.match(part));
  }, []);

  const parseMultipleSearchText = (temp: any) => {
    let sentence = temp?.trim();
    sentence = sentence
      ?.split(/[\s,]+/)
      ?.join()
      ?.split(',');
    return sentence;
  };

  const multipleSearch = (inputText: any) => {
    const batchNumberTest = /\d/;
    const vinTest = /^[A-Za-z0-9]*$/;

    // const conditionCheck = (currentValue: any) => {  return (currentValue?.length >= 10 && batchNumberTest.test(currentValue)) ||
    //   (currentValue?.length >= 18 && vinTest.test(currentValue)) }
    if (Array.isArray(inputText) && inputText?.length > 1) {
      return (
        (inputText[0]?.length >= 10 && batchNumberTest.test(inputText[0])) ||
        (inputText[0]?.length >= 18 && vinTest.test(inputText[0]))
      );
    }
    return false;
  };

  //   const isBelowThreshold = (currentValue) => currentValue < 40;

  // const array1 = [1, 30, 39, 29, 10, 13];

  // console.log(array1.every(isBelowThreshold));
  // Expected output: true

  return {
    quickFilterParser,
    quickFilterMatcher,
    filteredVins,
    setFilteredVins,
    parseMultipleSearchText,
    multipleSearch,
  };
};
